import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

import { Card, Heading, Button } from '../../shared/ui';

import { DocumentActions } from './document-actions';

import { DemoBanner } from './DemoBanner';

export function Supervision() {
  const [generated, setGenerated] = useState(true);
  const [selectedCount, setSelectedCount] = useState('1 сессия выбрана');

  return (
    <div className="space-y-4">
      <DemoBanner section="Для супервизии" />

      <div className="bg-white border border-line rounded-control p-5 flex items-center gap-4">
        <span className="text-ink-subtle text-ui" aria-hidden>
          ℹ
        </span>

        <div
          className="flex-1 border border-line rounded-control px-4 py-2 flex items-center justify-between cursor-pointer hover:bg-surface-muted"
          role="button"
          tabIndex={0}
          onClick={() => {
            setSelectedCount('1 сессия выбрана');
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') setSelectedCount('1 сессия выбрана');
          }}
        >
          <span className="text-ui text-ink-muted">{selectedCount}</span>
          <ChevronDown size={14} className="text-ink-subtle" />
        </div>

        <Button size="md" variant={generated ? 'report' : 'primary'} onClick={() => setGenerated((v) => !v)}>
          {generated ? 'Сгенерировано' : 'Генерировать'}
        </Button>
      </div>

      {generated && (
        <Card radius="control">
          <div className="flex items-center justify-between mb-4 pb-4 border-b border-surface-muted">
            <Heading size="lg" as="h3">
              Резюме для супервизии
            </Heading>

            <DocumentActions />
          </div>

          <div className="mb-4 pb-4 border-b border-surface-muted">
            <p className="text-ui-strong text-ink-muted mb-2">На основе сессий:</p>
            <ul className="text-ui text-ink-muted space-y-1">
              <li>• Вторник, 17 декабря — Управление тревогой: новые стратегии самопомощи.</li>
            </ul>
          </div>

          <div className="space-y-6 text-ui text-ink-muted">
            <section>
              <Heading size="sm" as="h4" className="mb-2">
                Демографические данные (Dgr), Семейная констелляция (F), Проблема (PP), Релевантный анамнез (Hx)
              </Heading>
              <p className="mb-1">Dgr: 26 лет, предприниматель, ГТР, владелец малого бизнеса</p>
              <p className="mb-1">F: Родители в разводе с детства, клиент брал роль опекуна для младшего брата</p>
              <p className="mb-1">PP: Рабочий стресс, трудности с самопомощью, баланс работы и жизни</p>
              <p>Hx: Эмоциональное пренебрежение в детстве, паттерны перфекционизма</p>
            </section>

            <section>
              <Heading size="sm" as="h4" className="mb-2">
                Предъявляемые жалобы (S), Красные флаги (RF), Клинические интервенции (T/P), Рекомендации (Rx), Реакция
                клиента (R)
              </Heading>
              <p className="mb-1">
                S: Фрустрация из-за некомпетентного ассистента, вина при установлении границ, 10% выполнение плана
                самопомощи.
              </p>
              <p className="mb-1">
                RF: Высокий уровень злости и фрустрации, фантазии о вербальной агрессии к сотруднику.
              </p>
              <p className="mb-1">
                T/P: Ролевая игра для профессиональной конфронтации. Терапевт направил клиента через структурированную
                обратную связь. Исследованы глубинные чувства (злость, тревога, поражение).
              </p>
              <p className="mb-1">
                Rx: Практика структурированного разговора с ассистентом с помощью шаблона ролевой игры. Чёткие ожидания
                и временные рамки.
              </p>
              <p>
                R: Изначально сопротивлялась (&quot;ваша идея с ролевой игрой - глупость&quot;), но включилась.
                Продемонстрировала готовность пробовать конструктивный подход.
              </p>
            </section>

            <section>
              <Heading size="sm" as="h4" className="mb-2">
                Вопросы для супервизора
              </Heading>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <span className="text-ink-subtle mt-0.5">•</span>
                  <span>Как более эффективно работать с сопротивлением клиента в начале сессии?</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-ink-subtle mt-0.5">•</span>
                  <span>Стоит ли интенсифицировать работу с детскими паттернами привязанности?</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-ink-subtle mt-0.5">•</span>
                  <span>Нужна ли дополнительная оценка рисков с учётом интенсивности злости клиента?</span>
                </li>
              </ul>
            </section>
          </div>
        </Card>
      )}
    </div>
  );
}
